import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Mail, Save, CheckCircle2 } from 'lucide-react';
import { useAuth } from '@/providers/AuthProvider';
import { Card, CardDescription, CardTitle } from '@/components/ui/Card';
import { Input, Label, FieldError, FieldHint } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/**
 * Card affichée sur la page Profil quand le compte courant est anonyme.
 * Lie un email pour transformer l'invité en compte permanent — préserve XP,
 * scores, amis et achievements.
 */
export function LinkEmailCard() {
    const { linkEmailToAnonymousAccount } = useAuth();
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [pending, setPending] = useState(false);
    const [sent, setSent] = useState(null); // email envoyé
    async function onSubmit(e) {
        e.preventDefault();
        setError(null);
        const trimmed = email.trim();
        if (!EMAIL_REGEX.test(trimmed)) {
            setError("Format d'email invalide.");
            return;
        }
        setPending(true);
        const res = await linkEmailToAnonymousAccount(trimmed);
        setPending(false);
        if (!res.ok) {
            setError(res.error ?? 'Échec de l\'envoi.');
            return;
        }
        setSent(trimmed);
        setEmail('');
    }
    if (sent) {
        return (_jsx(Card, { variant: "glow", padding: "lg", children: _jsxs("div", { className: "flex items-start gap-3", children: [_jsx(CheckCircle2, { className: "h-6 w-6 shrink-0 text-emerald-400" }), _jsxs("div", { className: "flex-1", children: [_jsx(CardTitle, { children: "Email de confirmation envoy\u00E9" }), _jsxs(CardDescription, { className: "mt-2", children: ["Clique sur le lien envoy\u00E9 \u00E0 ", _jsx("strong", { className: "text-ink-100", children: sent }), " pour valider ton compte. Ton historique (XP, scores, amis) est conserv\u00E9 tel quel."] }), _jsx(Button, { variant: "ghost", size: "sm", className: "mt-3", onClick: () => {
                                    setSent(null);
                                    setEmail('');
                                }, children: "Changer d'email" })] })] }) }));
    }
    return (_jsx(Card, { variant: "flame", padding: "lg", children: _jsxs("div", { className: "space-y-3", children: [_jsxs("div", { className: "flex items-start gap-3", children: [_jsx(Mail, { className: "h-6 w-6 shrink-0 text-flame-300" }), _jsxs("div", { children: [_jsx(CardTitle, { children: "Sauvegarde ton compte" }), _jsx(CardDescription, { className: "mt-1", children: "Tu joues en invit\u00E9. Associe un email pour ne pas perdre ton historique si tu changes de navigateur ou nettoies les cookies \u2014 pas de mot de passe \u00E0 retenir." })] })] }), _jsxs("form", { onSubmit: (e) => void onSubmit(e), className: "space-y-2", children: [_jsx(Label, { htmlFor: "link-email-input", required: true, children: "Email" }), _jsxs("div", { className: "flex gap-2", children: [_jsx(Input, { id: "link-email-input", type: "email", autoComplete: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "vous@exemple.fr", leftIcon: _jsx(Mail, { className: "h-4 w-4" }), invalid: !!error, className: "flex-1" }), _jsx(Button, { type: "submit", variant: "flame", isLoading: pending, leftIcon: _jsx(Save, { className: "h-4 w-4" }), children: "Lier" })] }), error ? (_jsx(FieldError, { children: error })) : (_jsx(FieldHint, { children: "On t'envoie un lien magique de confirmation." }))] })] }) }));
}
